export function slugify(string) {
  return string.toLowerCase()
    .trim()
    .replace(/ /g,'-')
    .replace(/[^\w-]+/g,'');
}

export function addThousandSeparator(number) {
  return number.toLocaleString('en-US');
}

export function cloneObject(obj) {
  var clone = {};

  for (var i in obj) {
    if (obj[i] !== null && typeof(obj[i]) === 'object') {
      clone[i] = cloneObject(obj[i]);
    } else {
      clone[i] = obj[i];
    }
  }
  return clone;
}

export function convertToMillion(value) {
  const millionValue = value / 1000000;
  return Math.round(millionValue * 10) / 10;
}



// WEBPACK FOOTER //
// ./src/helpers/format.js